import { render, staticRenderFns } from "./DataDestructionReports.vue?vue&type=template&id=38404e4a&scoped=true&"
import script from "./DataDestructionReports.vue?vue&type=script&lang=js&"
export * from "./DataDestructionReports.vue?vue&type=script&lang=js&"
import style0 from "./DataDestructionReports.vue?vue&type=style&index=0&id=38404e4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38404e4a",
  null
  
)

export default component.exports